import { css } from 'styled-components';

const styles = css`
  .plcc-text .text-style-1 {
    color: ${(props) => props.theme.colors.TEXT.ORANGE};
    text-transform: capitalize;
  }
  .plcc-text .text-style-2 {
    color: ${(props) => props.theme.colors.TEXT.LIGHTBLUE};
    text-transform: capitalize;
  }
  .plcc-text .text-style-3 {
    color: ${(props) => props.theme.colors.TEXT.DARKPINK};
    text-transform: capitalize;
  }

  .plcc-text .text-style-4 {
    color: #595959;
    text-transform: capitalize;
  }
`;

export default styles;
